import React, { useEffect } from "react";
import AppBar from "../../components/appBar";
import Footer from "../../components/footer";
import Crops from "./components/crops";
import MahsoolGuide from "./components/mahsool-guide";
import Weather from "./components/weather";
import Prices from "./components/prices";
import Services from "./components/services";
import Header from "./components/header";
import { useRef } from "react";
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet'
import { logActivity } from "../../api";

function Home() {
  const div = useRef(null);
  const scrollRef = useRef(null);
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Home",
  });

  const isAuth = !!localStorage.getItem("token"); // or your existing auth logic

  useEffect(() => {
    logActivity("Visit Home Page", "Page Visit", null, isAuth);
  }, []);

  return (
    <div className="overflow-x-hidden w-full" ref={div}>
      <Helmet>
        ‍<title>محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="محصول" />
        <meta
          property="og:description"
          content="بوابتك للمعلومات و الاسواق الزراعية"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <AppBar key="1" />
      <div>
        <Header div={div} />
      </div>
      <div>
        <Crops />
      </div>
      <div>
        <Prices />
      </div>
      <div>
        <Services />
      </div>
      <div>
        <MahsoolGuide />
      </div>
      <div>
        <Weather />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default Home;
